module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDisplayed) ? _c('div', {
    staticClass: "zoom-in-place zoom-component",
    style: (_vm.zoomStyle),
    on: {
      "mousemove": function($event) {
        $event.stopPropagation();
        _vm.setZoomEvent(true, $event)
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.setZoomEvent(false)
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-151199df!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/tooltip/ZoomInPlace.vue
// module id = 330
// module chunks = 1